// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isMetamaskInstalled = () => typeof (window as any).ethereum !== 'undefined'

export const isUserDeniedError = (error: { message: string }) =>
  error.message.includes('User denied transaction signature')

export const MetamaskErrors = {
  TRANSACTION_REJECTED: 4001,
}
